export default class HandleSearch {
  constructor(element) {
    this.inputToggler = element;
    this.input = document.querySelector('.js--search-input');
    this.form = document.querySelector('.js--search-form');
    this._setDOMReferences();
    this.checkState();
  }

  _setDOMReferences() {
    this.inputToggler.addEventListener('click', (e) => {
      setTimeout(() => {
        this.checkState();
      }, 100);
    });
    this.input.addEventListener('change', (e) => {
      if (e.keyCode == 13){
        //Enter is hit and toggle and submit form
        this.checkState();
        this.form.submit();
      }
    });
  }

  checkState() {
    let state = this.inputToggler.dataset.state;
    if (state === 'passive'){
      this.input.blur();
    } else if (state === 'active' ) {
      this.input.focus();
    }
  }
}
